import angular from 'angular';

import tszLoading from './tsz-loading';

const tszLoadingModule = angular.module('tsz.components.tszLoading', [])
  .component('tszLoading', tszLoading);

export default tszLoadingModule;



// WEBPACK FOOTER //
// ./src/components/tsz-loading/tsz-loading.module.js